// NEW: UI_REVAMP
import {
	Accordion,
	AccordionButton,
	AccordionIcon,
	AccordionItem,
	AccordionPanel,
	Flex,
	Image,
	Text,
} from '@chakra-ui/react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { betMenu, menuItems } from '../../constant/menuItems';
import { DrawerButton } from './DrawerButton';
import { GlassAccordionButton } from './GlassAccordionButton';

export const MenuList = ({
	isAgent = false,
	isThirdPartyLogin = false,
	handleBetNavigation,
	navigateWithReset,
	onClickLogout,
	isMobile = false,
}) => {
	const location = useLocation();

	return (
		<>
			<Accordion defaultIndex={[0]} allowToggle={!isMobile} allowMultiple={isMobile}>
				<AccordionItem style={{ border: 'none' }}>
					<AccordionButton
						mb={1}
						_hover={{ bg: isMobile ? 'none' : 'transparent', boxShadow: 'none' }}
						_active={{ bg: 'transparent' }}
						_focus={{ boxShadow: 'none' }}
						_expanded={{ bg: 'transparent' }}
						display='flex'
						justifyContent='space-between'
						px={isMobile ? undefined : 6}
						pb={isMobile ? 2.5 : undefined}
					>
						<Flex align='center' gap={isMobile ? undefined : 3}>
							<Image
								src='./assets/icons/bet.svg'
								w={6}
								h={6}
								ml={isMobile ? 2 : undefined}
								mr={isMobile ? 3 : undefined}
							/>
							<Text fontSize='20px' fontWeight='500'>
								Bet
							</Text>
						</Flex>
						<AccordionIcon />
					</AccordionButton>
					<AccordionPanel
						_hover={{ bg: 'transparent' }}
						padding={0}
						margin={0}
						display='flex'
						flexDirection='column'
						gap={2}
						mb={1}
					>
						{betMenu(handleBetNavigation, location.pathname).map(({ isPath, name, onClick }) => (
							<GlassAccordionButton key={name} {...{ isPath, name, onClick }} />
						))}
					</AccordionPanel>
				</AccordionItem>
			</Accordion>

			<Flex direction='column' gap={4} pb={isMobile ? undefined : 4}>
				{menuItems(isAgent).map((item) => (
					<DrawerButton
						key={item.name}
						name={item.name}
						imgSrc={item.icon}
						path={item.path}
						onClick={() => navigateWithReset(item.path)}
					/>
				))}

				{!isThirdPartyLogin && (
					<DrawerButton name='Log Out' imgSrc='/assets/icons/log-out.svg' onClick={onClickLogout} />
				)}
			</Flex>
		</>
	);
};

MenuList.propTypes = {
	isAgent: PropTypes.bool,
	isThirdPartyLogin: PropTypes.bool,
	handleBetNavigation: PropTypes.func.isRequired,
	navigateWithReset: PropTypes.func.isRequired,
	onClickLogout: PropTypes.func.isRequired,
	isMobile: PropTypes.bool,
};
export default MenuList;
